export const POSTER_VARIANTS = {
    VARIANT_1: 'variant_1',
    VARIANT_2: 'variant_2',
    VARIANT_3: 'variant_3',
    VARIANT_4: 'variant_4',
    VARIANT_5: 'variant_5',
    VARIANT_6: 'variant_6',
} as const;

export const STATIC_STATE_DELAY_S = 15;
export const QR_DURATION_S = 5;
export const ANIMATION_IN_DURATION_S = 1.5;
export const ANIMATION_OUT_DURATION_S = 1.5;

export const CAROUSEL_ITEM_PADDING = 2.6; // 50px
export const CAROUSEL_ITEM_HEADER_HEIGHT = 6.4; // 123px
export const CAROUSEL_ITEM_ACTIVATION_DELAY = 2;
